module.exports = __webpack_public_path__ + "img/signal-stream-slash.ae3d8b77.svg";